module.exports = __webpack_public_path__ + "static/media/diamond.7b15636a.svg";